import { Reveal } from "./Reveal";

export const About = () => (
  <section id="about" className="py-24 px-6 md:px-10 bg-[#FAF6F0] border-b border-[#0D2121]/10" data-testid="about-section">
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <Reveal className="lg:col-span-5 space-y-6">
        <span className="text-xs uppercase tracking-widest text-[#c88c2a] font-semibold">About Griham Design</span>
        <h2 className="font-display text-3xl sm:text-4xl text-[#0D2121] font-normal leading-tight">
          Crafting spaces that breathe Indian light and contemporary calm
        </h2>
        <p className="text-[#7A6F66] text-base leading-relaxed">
          Griham was established to bridge the gap between design vision and real-world turnkey execution. We design homes, offices, cafes, and boutique retail spaces where organic textures, brass nuances, solid woods, and effortless flow coexist.
        </p>
        <p className="text-[#7A6F66] text-base leading-relaxed">
          Whether you are building a new family residence from scratch, remodeling an existing apartment, or setting up a flagship cafe, we supervise every carpenter, finish, and lighting fixture.
        </p>
        <div className="pt-2 border-t border-[#0D2121]/10 grid grid-cols-2 gap-6 text-sm">
          <div>
            <div className="font-display text-xl text-[#0D2121] font-semibold">Turnkey</div>
            <div className="text-[#7A6F66] text-xs">Concept to Final Polish</div>
          </div>
          <div>
            <div className="font-display text-xl text-[#0D2121] font-semibold">Anywhere</div>
            <div className="text-[#7A6F66] text-xs">Physical &amp; Online Consults</div>
          </div>
        </div>
      </Reveal>

      <Reveal className="lg:col-span-7" delay={120}>
        <div className="relative aspect-[4/3] rounded-sm overflow-hidden border border-[#0D2121]/10 shadow-sm">
          <img
            src="https://images.pexels.com/photos/37471990/pexels-photo-37471990.jpeg"
            alt="Designer moodboard with terracotta, teak, brass, and fabric swatches"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-x-0 bottom-0 flex items-end p-8 bg-gradient-to-t from-[#0D2121]/40 to-transparent">
            <span className="text-xs tracking-wider uppercase text-[#0D2121]/80 bg-[#FAF6F0]/85 px-3 py-1 backdrop-blur-sm">
              Studio Material Palette &amp; Detail Focus
            </span>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
